module.exports = __webpack_public_path__ + "img/white.2db4599e.webp";